export const DEFAULT_MIN_YEAR = new Date(new Date().getFullYear(), 0);
export const DEFAULT_MAX_YEAR = new Date(9999, 11);
